<template>
  <button
    @click="toggle"
    :class="isLiked ? 'text-danger' : 'text-muted'">
    <template v-if="isLiked">
      <i class="fas fa-heart"></i>
    </template>
    <template v-else>
      <i class="far fa-heart"></i>
    </template>
    {{ count ? count : '' }}
  </button>
</template>

<script>
import apiAgent from '../common/api_agent'

export default {
  props: ['magKey', 'likeCount', 'alreadyLiked'],
  data() {
    return { isLiked: false }
  },
  mounted() {
    this.isLiked = this.alreadyLiked
  },
  computed: {
    count() {
      if (this.alreadyLiked) {
        return this.isLiked ? this.likeCount : this.likeCount - 1
      }

      return this.isLiked ? this.likeCount + 1 : this.likeCount
    }
  },
  methods: {
    toggle() {
      if (this.isLiked) {
        this.isLiked = false
        apiAgent({ url: `/api/mags/${this.magKey}/like`, method: 'DELETE' })
      } else {
        this.isLiked = true
        apiAgent({ url: `/api/mags/${this.magKey}/like`, method: 'POST' })
      }
      return
    }
  }
}
</script>

<style scoped>
button, button:hover, button:active, button:focus {
  background-color: transparent;
  border: 0;
  outline: none;
  margin-top: 4px;
}
</style>
